import { Box, Flex } from '@chakra-ui/react';
import { type User } from '@halo/chat-sdk-react';
import { UserItem } from '@halo/ui-chat-react';
import { MyTrans, Checkmark } from '@halo/ui-react';

export interface GroupJoinRequest extends User {
  added: boolean;
}

interface JoinItemProps {
  member: GroupJoinRequest;
  onMemberAvatarClick?: (member: GroupJoinRequest) => void;
  isChecked: boolean;
  isDisabled: boolean;
  onClick: () => void;
  isLast: boolean;
}

export const JoinItem = ({
  member,
  onMemberAvatarClick,
  isChecked,
  isDisabled,
  onClick,
  isLast,
}: JoinItemProps) => {
  return (
    <UserItem
      key={member?.user_id}
      {...member}
      rippleEffect={false}
      hoverable={false}
      onAvatarClick={() => onMemberAvatarClick?.(member)}
      startElement={
        <Checkmark
          filled
          size="sm"
          borderRadius="sm"
          cursor={isDisabled ? 'not-allowed' : 'pointer'}
          disabled={isDisabled}
          onClick={onClick}
          checked={isChecked}
        />
      }
      onClick={onClick}
      userExtraElement={
        <>
          <Flex fontWeight="medium">
            {/* <Box color="fg.subtle" fontSize="sm">
              Rejected
            </Box> */}
            {member.added ? (
              <Box color="fg.subtle" fontSize="sm">
                <MyTrans i18nKey="buttons.accepted" />
              </Box>
            ) : null}
          </Flex>
        </>
      }
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      borderColor={isLast ? 'transparent' : 'border.subtle'}
    />
  );
};
